import { PublicWaitlistCustomText } from '@shared/restaurant/models';

export function getDefaultCustomText(restaurantName: string): PublicWaitlistCustomText {
  return {
    footer: null,
    waitlist: {
      view: {
        text: `<h1 style="text-align: center">${restaurantName} Waitlist</h1>`,
      },
      add: {
        text: '<h1 style="text-align: center">${restaurantName} Waitlist</h1>',
      },
    },
    bookings: {
      view: {
        text: '<h1 style="text-align: center">${restaurantName} Reservations</h1>',
      },
      add: {
        text: '<h1 style="text-align: center">Your ${restaurantName} Waitlist</h1>',
      },
    },
    closed: '<h2 class="ql-align-center"><span style="color: rgb(255, 255, 255)">Sorry, we\'re closed now. Our hours are {hours}.</span></h2>',
  }
}
